import { createReducer } from '@reduxjs/toolkit';
import type { IWebNotification } from '../../api/domain';
import { fetchWebNotificationsSuccess } from './notifications-api-actions';

interface INotificationsApiState {
    webNotifications: IWebNotification[];
    totalNotificationCount: number;
}
export type { INotificationsApiState };

export const initialState: INotificationsApiState = { webNotifications: [], totalNotificationCount: 0 };

export const notificationsApiReducer = createReducer(initialState, (builder) => {
    builder.addCase(fetchWebNotificationsSuccess, (state, { payload: { notifications, totalCount } }) => {
        state.webNotifications = notifications;
        state.totalNotificationCount = totalCount;
    });
});
